module.exports = __webpack_public_path__ + "static/how-it-works-step3-1b85bbe4a97a71335ca63678748462f0.svg";